<template>
  <!-- Dashboard Content
	================================================== -->
  <div class="dashboard-content-container" data-simplebar>
    <div class="dashboard-content-inner">
      <!-- Dashboard Headline -->
      <div class="dashboard-headline">
        <h3>Saved Jobs</h3>

        <!-- Breadcrumbs -->
        <nav id="breadcrumbs" class="dark">
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">Dashboard</a></li>
            <li>Saved Jobs</li>
          </ul>
        </nav>
      </div>

      <!-- Row -->
      <div class="row" v-if="favouriteProjects && favouriteProjects.length">
        <!-- Dashboard Box -->
        <div class="col-xl-12">
          <div class="dashboard-box margin-top-0">
            <!-- Headline -->
            <div class="headline">
              <h3><i class="icon-material-outline-business-center"></i> {{ totalSavedJobs }} Saved Jobs</h3>
            </div>

            <div class="content">
              <ul class="dashboard-box-list">
                <li v-for="favProject in favouriteProjects" :key="favProject.id">
                  <!-- Job Listing -->
                  <div class="job-listing">
                    <!-- Job Listing Details -->
                    <div class="job-listing-details">
                      <!-- Logo -->
                      <a href="#" class="job-listing-company-logo">
                        <img :src="favProject.project.photos[0]['url']" alt="" />
                      </a>

                      <!-- Details -->
                      <div class="job-listing-description">
                        <h3 class="job-listing-title"
                          ><router-link :to="`/project-details?id=${favProject.id}`">{{
                            `${favProject.project.task.name} - ${favProject.project.subtask.name}`
                          }}</router-link></h3
                        >

                        <!-- Job Listing Footer -->
                        <div class="job-listing-footer">
                          <ul>
                            <li
                              ><i class="icon-material-outline-account-balance-wallet"></i>
                              {{ `${NAIRA} ${favProject.project.budget.toLocaleString()}` }}</li
                            >
                            <li
                              ><i class="icon-material-outline-location-on"></i>
                              {{ favProject.project.region.name }}</li
                            >
                            <li
                              ><i class="icon-material-outline-business-center"></i>
                              {{ favProject.project.model === 1 ? 'Remote' : 'On-site' }}</li
                            >
                            <li
                              ><i class="icon-material-outline-access-time"></i>
                              {{ formatDate(favProject.project.updatedAt) }}</li
                            >
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>

              <!-- Pagination -->
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <!-- Projects -->
                  <div class="pagination-container margin-top-30 margin-bottom-60">
                    <nav class="pagination">
                      <ul>
                        <li class="pagination-arrow" :class="[prevPageUrl === null ? 'isDisabled' : '']"
                          ><a href="#" class="ripple-effect" @click="getPrevPage()"
                            ><i class="icon-material-outline-keyboard-arrow-left"></i></a
                        ></li>

                        <li v-for="index in paginationTotal" :key="index">
                          <a
                            href="#"
                            @click="getFavouriteProjects(index)"
                            class="ripple-effect"
                            :class="[currentPage === index ? 'current-page' : '']"
                            >{{ index }}</a
                          >
                        </li>
                        <li class="pagination-arrow " :class="[nextPageUrl === null ? 'isDisabled' : '']"
                          ><a href="#" class="ripple-effect" @click="getNextPage()"
                            ><i class="icon-material-outline-keyboard-arrow-right"></i></a
                        ></li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
              <!-- Pagination / End -->
            </div>
          </div>
        </div>
      </div>
      <!-- Row / End -->

      <!-- Footer -->
      <app-footer></app-footer>
      <!-- Footer / End -->
    </div>
  </div>
  <!-- Dashboard Content / End -->
</template>

<script>
  /* eslint-disable no-console */
  import { AppFooter } from '../../partials/user-dashboard';
  import { getCall } from '../../../core/services/http.service';
  import { GET_FAVOURITE_PROJECTS } from '../../../core/config/endpoints/projects';
  import { NAIRA } from '../../../plugins/config/constants';
  import { formatDate } from '../../../plugins/handlers';
  
  export default {
    name: 'SavedJobs',
    components: {
      AppFooter,
    },
    data() {
      return {
        favouriteProjects: [],
        currentPage: 1,
        firstPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        paginationTotal: 0,
        itemsPerPage: 0,
        totalSavedJobs: 0,
        NAIRA: NAIRA,
      };
    },
    methods: {
      getFavouriteProjects(pageNumber = 1) {
        this.$store.commit('setIsLoaded', true);
        pageNumber = pageNumber ? pageNumber : this.currentPage;
        getCall(`${GET_FAVOURITE_PROJECTS}?page=${pageNumber}`)
          .then((response) => {
            this.favouriteProjects = response.data.data.data;
            this.firstPageUrl = response.data.data.first_page_url;
            this.nextPageUrl = response.data.data.next_page_url;
            this.prevPageUrl = response.data.data.prev_page_url;
            this.totalSavedJobs = response.data.data.total;
            this.itemsPerPage = response.data.data.per_page;
            this.currentPage = response.data.data.current_page;
            this.getPaginationTotal();
          })
          .catch((error) => {
            console.log(error.response.data.message);
          })
          .finally(() => {
            this.$store.commit('setIsLoaded', false);
          });
      },
      viewProject(id) {
        this.$router.push({
          name: 'ProjectDetails',
          query: { id: `${id}` },
        });
      },
      getPrevPage() {
        this.currentPage--;
        return this.getFavouriteProjects();
      },

      getNextPage() {
        this.currentPage++;
        return this.getFavouriteProjects();
      },
      getPaginationTotal() {
        this.paginationTotal = Math.ceil(this.totalSavedJobs / this.itemsPerPage);
      },
      formatDate(dateTime) {
        return formatDate(dateTime);
      },
    },
    mounted: function() {
      this.getFavouriteProjects();
    },
  };
</script>

<style></style>
